/** */
import axios from 'axios';

/** */
const extractErrorField = (e, field) => {
  let result = 'An error occurred. Please try again later.';
  if (e && e.response && e.response.data) {
    result = e.response.data[field];
  }

  return result;
};

const DEFAULT_ERR = (error) => ({
  error: extractErrorField(error, 'error'),
  status_code: extractErrorField(error, 'status_code'),
  payload: null
});

/** */
export const apiDelete = async (uri, options = {}) => {
  try {
    const { data, token } = options;
    const request = await axios.delete(`${uri}`, {
      data,
      headers: {
        authorization: `Bearer ${token}`
      }
    });

    return request.data;
  } catch (e) {
    return DEFAULT_ERR(e);
  }
};

export const apiGet = async (uri, options = {}, tries = 1) => {
  try {
    const { token, query_string } = options;
    const request = await axios.get(`${uri}?${query_string || ''}`, {
      headers: {
        authorization: `Bearer ${token}`
      }
    });

    return request.data;
  } catch (e) {
    if (tries < 3) return await apiGet(uri, options, tries + 1);
    return DEFAULT_ERR(e);
  }
};

export const apiPost = async (uri, options = {}) => {
  try {
    const { data, headers, token } = options;
    const request = await axios.post(`${uri}`, data, {
      headers: {
        ...headers,
        authorization: `Bearer ${token}`
      }
    });

    return request.data;
  } catch (e) {
    return DEFAULT_ERR(e);
  }
};

export const apiPut = async (uri, options = {}) => {
  try {
    const { data, token } = options;
    const request = await axios.put(`${uri}`, data, {
      headers: {
        authorization: `Bearer ${token}`
      }
    });

    return request.data;
  } catch (e) {
    return DEFAULT_ERR(e);
  }
};

export const TinyMCEUpload = async (uri, success, failure, progress, options = {}) => {
  const { data, token } = options;

  axios
    .post(uri, data, {
      headers: {
        authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
      const { error, payload } = response.data;
      if (error) return failure(error, { remove: true });
      success(payload.location);
    })
    .catch((e) => {
      failure(e.response.data.error, { remove: true });
    });
};
